export const AdminJoinApplicationController = {
    index(): void {},
    export(): void {},
    show(): void {},
    bulkDestroy(): void {},
    destroy(): void {},
};
